import {Post, Workshop} from "../types";

interface Props {
    languages: string[]
    items: Post[] | Workshop[]
}

export const filterByLanguages = ({ languages, items }: Props): any[] =>
    languages.length ? items.filter(item => languages.includes(item.language)) : items
